<script>
import Banner from "../components/PageBanner";
import Section from "./../components/PageSection";
import Calendrier from "./../components/temps/Calendrier";
import Projet from "./../components/temps/Card";
import Form from "./../components/PageForm";
import TabMenu from "../components/PageTabMenu";
import Tab from "../components/PageTab";
import Spinner from "../components/Spinner";
import Footer from "../components/Footer";
import { updateMontant } from "../mixins/updateMontant";
import { mapGetters } from "vuex";

export default {
  name: "PageTemps",
  components: {
    Banner,
    Section,
    Calendrier,
    Projet,
    Form,
    TabMenu,
    Tab,
    Spinner,
    Footer,
  },
  data() {
    return {
      modeSaisie: null,
      joursSemaine: [],
      projets: [],
      phases: [],
      phasesSelect: [], // Celles affiliées au projet sélectioné, qui apparaitront dans le select
      phasesDisplayed: [],
      nonFactDisplayed: [],
      absencesDisplayed: [],
      // tableauPhasesUser: [],
      month: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1,
        12,
        0,
        0
      ),
      fullyLoaded: false,
      joursMois: 0,
      deltaTemps: 21,
      ticketsRestaurant: 0,
      isValidated: false,
      dateDisplayed: new Date(),
    };
  },
  mixins: [updateMontant],
  // watch: {
  //   // whenever question changes, this function will run
  //   month: function (newVal, oldVal) {
  //     console.log(oldVal + ' > ' + newVal)
  //   },
  // },

  /////////////////////////////////
  //          Mounted            //
  /////////////////////////////////

  mounted() {
    //Est-ce qu'on est en jours ou en heures ?
    this.$axios
      .get("agences/mode/" + this.$store.state.auth.currentAgence._id)
      .then((res) => {
        this.modeSaisie = res.data;

        //Initialisation de la date
        this.joursSemaine = [];
        let lundi = new Date();
        lundi.setUTCDate(lundi.getUTCDate() - lundi.getUTCDay() + 1);

        if (this.modeSaisie === "heures") {
          this.setWeek(lundi);
        } else {
          this.setWeek(this.month);
        }

        for (let i = 0; i < 7; i++) {
          let day = new Date(lundi);
          this.joursSemaine.push(day);
          lundi.setUTCDate(lundi.getUTCDate() + 1);
        }
      })
      .catch((err) => console.log(err));

    // //Initialisation de this.tableauPhasesUser
    // this.$axios.get('users/self/' + this.$store.state.auth.currentUser._id)
    // .then(response => this.tableauPhasesUser = response.data.tableauPhases)
    // .catch(err => this.alert(err))

    //Remplissage de this.projets pour la liste déroulante du formulaire d'ajout de phase
    this.$axios
      .get("projets/actives/" + this.$store.state.auth.currentAgence._id)
      .then((response) => {
        this.projets = response.data;
      })
      .catch((e) => console.log(e));

    //Remplissage de this.phases pour la liste déroulante du formulaire d'ajout de phase
    this.$axios
      .get(
        "saisieTemps/phasesActivesByAgence/" +
          this.$store.state.auth.currentAgence._id
      )
      .then((response) => {
        this.phases = response.data;
      })
      .catch((e) => console.log(e));
  },

  /////////////////////////////////
  //         Computed            //
  /////////////////////////////////
  computed: {
    ...mapGetters({
      username: "auth/username",
      agence: "auth/agence",
    }),
    joursTravailles() {
      let somme = 0;

      for (let i = 0; i < this.phasesDisplayed.length; i++) {
        somme = somme + this.getTotalLine(1, i);
      }

      for (let i = 0; i < this.nonFactDisplayed.length; i++) {
        somme = somme + this.getTotalLine(2, i);
      }

      if (somme % 1 == 0) {
        return somme;
      } else {
        return somme.toFixed(1);
      }
    },
  },

  /////////////////////////////////
  //          Methods            //
  /////////////////////////////////

  methods: {
    changedPeriod(lundi) {
      this.dateDisplayed = lundi;

      if (this.modeSaisie === "heures") {
        this.joursSemaine = [];

        //Modifier les phases affichées et les temps contenus
        this.setWeek(lundi);

        //Modifier le Header avec les jours
        for (let i = 0; i < 7; i++) {
          let day = new Date(lundi);
          this.joursSemaine.push(day);
          lundi.setUTCDate(lundi.getUTCDate() + 1);
        }
      } else {
        this.month = new Date(lundi.getFullYear(), lundi.getMonth(), 1);
        this.month.setHours(9);
        //Modifier les phases affichées et les temps contenus
        this.setWeek(this.month);
      }

      this.ticketsRestaurant = 0;
    },

    //Method lancée via mounted ---
    async setWeek(lundi) {
      //On va chercher les heures saisies à partir de 00:00 UTC
      lundi.setUTCHours(0);
      lundi.setMinutes(0);
      lundi.setSeconds(0);

      //Remplissage de this.phasesDisplayed pour afficher les phases à afficher : celles où il y a des données sur cette semaine + celles du tableau persistant de l'utilisateur (user.tableauPhases)
      //La concaténation du tableau user et des phases où il y a des données se fait sur le serveur. La réponse renvoyée est complète.
      const promiseFacturable = this.$axios
        .get(
          "saisietemps/phasesDisplayed/" +
            this.$store.state.auth.currentUser._id +
            "/" +
            this.$store.state.auth.currentAgence._id +
            "/" +
            lundi
        )
        .then((response) => {
          this.phasesDisplayed = response.data;
        })
        .catch((err) => this.alert(err));

      //Idem nonfact
      const promiseNonFacturable = this.$axios
        .get(
          "saisietemps/nonFactDisplayed/" +
            this.$store.state.auth.currentUser._id +
            "/" +
            this.$store.state.auth.currentAgence._id +
            "/" +
            lundi
        )
        .then((response) => {
          this.nonFactDisplayed = response.data;
        })
        .catch((err) => this.alert(err));

      //Idem absences
      const promiseAbsences = this.$axios
        .get(
          "saisietemps/absencesDisplayed/" +
            this.$store.state.auth.currentUser._id +
            "/" +
            this.$store.state.auth.currentAgence._id +
            "/" +
            lundi
        )
        .then((response) => {
          this.absencesDisplayed = response.data;
        })
        .catch((err) => this.alert(err));

      //Est-ce qu'il y a déjà une feuille de saisie pour cet user ce mois-ci ?
      this.$axios
        .get(
          "feuilles/getByPage/" +
            this.$store.state.auth.currentUser._id +
            "/" +
            this.month
        )
        .then((response) => {
          if (response.data.length > 0) {
            this.isValidated = true;
            this.ticketsRestaurant = response.data[0].ticketsRestaurant;
          } else {
            this.isValidated = false;
          }
        })
        .catch((err) => this.alert(err));

      await Promise.all([
        promiseFacturable,
        promiseNonFacturable,
        promiseAbsences,
      ]);
      this.fullyLoaded = true;
    },

    //Mettre à jour la liste déroulante de la form en fonction du projet sélectionné
    majPhases(projetId) {
      //Si l'user vient de sélectionner la première option "projet", on vide la liste des phases
      if (projetId === "") {
        this.phasesSelect = [];
        //On traite les cas des tâches non facturables
      } else if (projetId === "taches") {
        this.$axios
          .get("nonfact/unflagged/" + this.$store.state.auth.currentAgence._id)
          .then((response) => {
            //Parmis les phases de ce projet, sortir les phases déjà affichées et les absences
            let i = 0;

            response.data.forEach((p) => {
              this.nonFactDisplayed.forEach((pd) => {
                if (pd._id === p._id) {
                  response.data[i] = null;
                }
              });
              i++;
            });
            this.phasesSelect = response.data.filter(function (e) {
              return e != null;
            });
          });

        //On traite les absences
      } else if (projetId === "absences") {
        this.$axios
          .get("absences/unflagged/" + this.$store.state.auth.currentAgence._id)
          .then((response) => {
            //Parmis les phases de ce projet, sortir les phases déjà affichées et les absences
            let i = 0;

            response.data.forEach((p) => {
              this.absencesDisplayed.forEach((a) => {
                if (a._id === p._id) {
                  response.data[i] = null;
                }
              });
              i++;
            });
            this.phasesSelect = response.data.filter(function (e) {
              return e != null;
            });
          });

        //Si c'est vraiment un projet, on va chercher les phases associées
      } else {
        //Je vais les chercher dans this.phases (toutes les phases des projets actifs)
        let myArray = this.phases.filter((e) => e.projetId == projetId);
        myArray.sort((a, b) =>
          a.rankTyped > b.rankTyped ? 1 : b.rankTyped > a.rankTyped ? -1 : 0
        );

        // Parmis les phases de ce projet, sortir les phases déjà affichées (elles deviennent null)
        let i = 0;
        myArray.forEach((p) => {
          this.phasesDisplayed.forEach((pd) => {
            if (pd._id === p._id) {
              myArray[i] = null;
            }
          });
          i++;
        });

        //Je ne prend les non null
        this.phasesSelect = myArray.filter(function (e) {
          return e != null;
        });

        //Ancienne version, je requète à chaque fois.
        // this.$axios.get('saisietemps/phasesByProjet/' + projetId + "/" + this.$store.state.auth.currentAgence._id)
        // .then(response => {
        //   //Parmis les phases de ce projet, sortir les phases déjà affichées
        //   let i=0;

        //   response.data.forEach(p => {
        //     this.phasesDisplayed.forEach(pd => {
        //       if (pd._id === p._id){
        //         response.data[i] = null
        //       }
        //     })
        //     i++
        //   });
        //   this.phasesSelect = response.data.filter(function (e) {
        //     return e != null;
        //   });
        // })
        // .catch(e => {
        //   console.log(e);
        // });
      }
    },

    //Ajouter une phase à celles qui sont affichées
    add(payload) {
      if (payload.length == 2 && payload[1] != "") {
        //Le formulaire renvoi les informations de base (payload), je complète avec des heures vides pour ne pas qu'il y ai d'erreurs à l'affichage des phasesDisplayed dans la boucle for du Html
        let item = {
          _id: payload[1], //De l'objet phase ou tache ou abscence
          projet: "", //Son nom (projet uniquement)
          projetId: "",
          name: "", //Nom de la phase, de la tâche ou de l'abscence
          isFav: false,
          heures: [],
          jours: [],
          heuresId: [],
          joursId: "",
        };

        if (payload[0] === "taches") {
          //Compléter avec le nom de la tache
          item.name = this.phasesSelect.find((e) => e._id == item._id).name;
          item.projet = "Tâches";
          this.nonFactDisplayed.push(item);
          //Par défaut, ajouter cette tâche ou phase aux favoris
          this.addfavoris(false, item._id, false);
        } else if (payload[0] === "absences") {
          item.name = this.phasesSelect.find((e) => e._id == item._id).name;
          item.projet = "Absence";
          this.absencesDisplayed.push(item);
          //Par défaut, ajouter cette tâche ou phase aux favoris
          this.addfavoris(false, false, item._id);
        } else {
          //Compléter avec le nom de la phase et le nom du projet
          item.name = this.phasesSelect.find((e) => e._id == item._id).name;
          let myProjet = this.projets.find((e) => e._id == payload[0]);
          item.projet = myProjet.name + " - " + myProjet.localisation;
          item.projetId = myProjet._id;

          this.phasesDisplayed.push(item);
          //Par défaut, ajouter cette tâche ou phase aux favoris
          this.addfavoris(item._id, false, false);
        }

        //Vider la liste des phases
        this.phasesSelect = [];
      }
    },

    //Ajouter une phase du tableau utilisateur
    addfavoris(phaseId, nonfactId, absenceId) {
      let item = {};
      item.phaseId = phaseId;
      item.nonfactId = nonfactId;
      item.absenceId = absenceId;

      this.$axios
        .put(
          "saisietemps/addfavoris/" + this.$store.state.auth.currentUser._id,
          item
        )
        .then((response) => {
          console.log(response.data.message);
          if (phaseId) {
            this.phasesDisplayed.find((e) => e._id === phaseId).isFav = true;
          } else if (nonfactId) {
            this.nonFactDisplayed.find((e) => e._id === nonfactId).isFav = true;
          } else if (absenceId) {
            this.absencesDisplayed.find(
              (e) => e._id === absenceId
            ).isFav = true;
          } else {
            console.log(
              "erreur dans l'ajout de favoris côté client, mais ok côté server. Appuyer sur F5."
            );
          }
        })
        .catch((e) => {
          console.log("erreur : " + e);
        });
    },

    //Supprimer une phase du tableau des favoris de l'utilisateur en cliquant sur l'étoile violette à la fin de la ligne de la phase affichée
    delfavoris(phaseId, nonfactId, absenceId) {
      let item = {};
      item.phaseId = phaseId;
      item.nonfactId = nonfactId;
      item.absenceId = absenceId;

      this.$axios
        .put(
          "saisietemps/delfavoris/" + this.$store.state.auth.currentUser._id,
          item
        )
        .then((response) => {
          console.log(response.data.message);
          if (phaseId) {
            this.phasesDisplayed.find((e) => e._id === phaseId).isFav = false;
          } else if (nonfactId) {
            this.nonFactDisplayed.find(
              (e) => e._id === nonfactId
            ).isFav = false;
          } else if (absenceId) {
            this.absencesDisplayed.find(
              (e) => e._id === absenceId
            ).isFav = false;
          } else {
            console.log(
              "erreur dans la suppression de favoris côté client, mais ok côté server. Appuyer sur F5."
            );
          }
        })
        .catch((e) => {
          console.log("erreur : " + e);
        });

      //S'il n'y a pas de données pour cet item, je le sort de l'affichage
      if (phaseId) {
        for (const [i, phase] of this.phasesDisplayed.entries()) {
          if (phase._id == item.phaseId) {
            if (this.getTotalLine(1, i) == 0) {
              this.phasesDisplayed.splice(i, 1);
            }
          }
        }
      } else if (nonfactId) {
        for (const [i, phase] of this.nonFactDisplayed.entries()) {
          if (phase._id == item.nonfactId) {
            if (this.getTotalLine(1, i) == 0) {
              this.nonFactDisplayed.splice(i, 1);
            }
          }
        }
      } else if (absenceId) {
        for (const [i, phase] of this.absencesDisplayed.entries()) {
          if (phase._id == item.absenceId) {
            if (this.getTotalLine(1, i) == 0) {
              this.absencesDisplayed.splice(i, 1);
            }
          }
        }
      }
    },

    //Ecrire, modifier et supprimer des temps
    changeTime(e, i, itemId, heuresId) {
      let time = {};

      if (this.nonFactDisplayed.find((e) => e._id == itemId)) {
        //Est-ce que l'on est en train d'ajouter un temps à un élément non facturable ? Est-ce que l'id de l'item correspond à un item de nonFactDisplayed ?
        time.nonfactId = itemId;
      } else if (this.absencesDisplayed.find((e) => e._id == itemId)) {
        //Est-ce que l'on est en train d'ajouter un temps à un élément non facturable ? Est-ce que l'id de l'item correspond à un item de nonFactDisplayed ?
        time.absenceId = itemId;
      } else {
        //non, c'est donc une phase d'un projet
        time.phaseId = itemId;
      }

      time.agenceId = this.$store.state.auth.currentAgence._id;
      time.userId = this.$store.state.auth.currentUser._id;
      time.date = this.joursSemaine[i];
      time.date.setUTCHours(12);
      time.volume = e.target.value;

      //Conversion d'un i avec lundi == 0 (DOM) à un j avec dimanche == 0 (Server)
      let j = (i + 1) % 7;

      //Y avait-il des temps de saisis avant changement (Y a-t-il déjà un item "temps" dans la BDD, donc une ID d'item dans this.phasesDisplayed ou this.nonFactDisplayed)
      if (heuresId) {
        //Si oui, est-ce que je la met à jour (nouvelle valeur) ou est-ce que je la supprime (plus de valeur)
        if (e.target.value === "0" || e.target.value === "") {
          //Nouvelle valeur nulle, je supprime le temps de la base
          this.$axios
            .delete("tempsHeures/" + heuresId)
            .then((res) => {
              this.alert(res);

              if (time.nonfactId) {
                //Est-ce que c'est un élément non facturable ?
                this.nonFactDisplayed.find((e) => e._id === itemId).heuresId[
                  j
                ] = null;
              } else if (time.absenceId) {
                //Est-ce que c'est une absence ?
                this.absencesDisplayed.find((e) => e._id === itemId).heuresId[
                  j
                ] = null;
              } else if (time.phaseId) {
                //Est-ce que c'est une phase d'un projet ?
                this.phasesDisplayed.find((e) => e._id === itemId).heuresId[j] =
                  null;
              } else {
                console.log(
                  "erreur, temps sans ID de phase ou de tache associée"
                );
              }

              //Graphiquement on supprime un éventuel 0 dans l'affichage client
              if (e.target.value === "0") {
                e.target.value = null;
              }
            })
            .catch((err) => err);
        } else if (!isNaN(e.target.value) && e.target.value > 0) {
          //Nouvelle valeur non nulle, je modifie la valeur existante
          this.$axios
            .put("tempsHeures/" + heuresId, time)
            .then((res) => {
              this.alert(res);
            })
            .catch((err) => this.alert(err));
        } else {
          this.alert("Valeur incorrecte");
          console.log(e.target.value);
        }
      } else {
        //Si non, j'ajoute un nouveau temps
        if (e.target.value !== "0") {
          this.$axios
            .post("tempsHeures/register", time)
            .then((res) => {
              this.alert(res);
              //Le mettre à jour dans phaseDisplayed
              if (time.nonfactId) {
                this.nonFactDisplayed.find((e) => e._id === itemId).heuresId[
                  j
                ] = res.data.tempsId;
              } else if (time.absenceId) {
                this.absencesDisplayed.find((e) => e._id === itemId).heuresId[
                  j
                ] = res.data.tempsId;
              } else {
                this.phasesDisplayed.find((e) => e._id === itemId).heuresId[j] =
                  res.data.tempsId;
              }
            })
            .catch((err) => this.alert(err));
        }
      }

      //Puisque les temps saisis ont bougés, le montant max de tickets restaurants est peut-être différent, je le remet à Zéro.
      this.ticketsRestaurant = 0;
    },

    //Ecrire, modifier et supprimer des jours
    changeJours(e, itemId, joursId) {
      let time = {};

      if (this.nonFactDisplayed.find((e) => e._id == itemId)) {
        //Est-ce que l'on est en train d'ajouter un temps à un élément non facturable ? Est-ce que l'id de l'item correspond à un item de nonFactDisplayed ?
        time.nonfactId = itemId;
      } else if (this.absencesDisplayed.find((e) => e._id == itemId)) {
        //Est-ce que l'on est en train d'ajouter un temps à un élément non facturable ? Est-ce que l'id de l'item correspond à un item de nonFactDisplayed ?
        time.absenceId = itemId;
      } else {
        //non, c'est donc une phase d'un projet
        time.phaseId = itemId;
      }

      time.agenceId = this.$store.state.auth.currentAgence._id;
      time.userId = this.$store.state.auth.currentUser._id;
      time.date = this.month; //Le premier jours du mois
      time.date.setUTCHours(12);
      time.volume = e.target.value;

      //Y avait-il des temps de saisis avant changement (Y a-t-il déjà un item "temps" dans la BDD, donc une ID d'item dans this.phasesDisplayed)
      if (joursId) {
        //Si oui, est-ce que je la met à jour (nouvelle valeur) ou est-ce que je la supprime (plus de valeur)
        if (
          e.target.value === "0" ||
          e.target.value === "" ||
          e.target.value === null
        ) {
          //Nouvelle valeur nulle, je supprime le temps de la base
          this.$axios
            .delete("tempsJours/" + joursId)
            .then((res) => {
              this.alert(res);

              if (time.nonfactId) {
                //Est-ce que c'est un élément non facturable ?
                this.nonFactDisplayed.find((e) => e._id === itemId).joursId =
                  null;
              } else if (time.absenceId) {
                //Est-ce que c'est une absence ?
                this.absencesDisplayed.find((e) => e._id === itemId).joursId =
                  null;
              } else if (time.phaseId) {
                //Est-ce que c'est une phase d'un projet ?
                this.phasesDisplayed.find((e) => e._id === itemId).joursId =
                  null;
              } else {
                console.log(
                  "erreur, temps sans ID de phase ou de tache associée"
                );
              }

              if (e.target.value === "0") {
                e.target.value = null;
              }
            })
            .catch((err) => this.alert(err));
        } else if (!isNaN(e.target.value) && e.target.value > 0) {
          //Nouvelle valeur non nulle, je modifie la valeur existante
          this.$axios
            .put("tempsJours/" + joursId, time)
            .then((res) => {
              this.alert(res);
            })
            .catch((err) => this.alert(err));
        } else {
          this.alert("Valeur incorrecte");
          console.log(e.target.value);
        }
      } else {
        //Si non, j'ajoute un nouveau temps
        if (e.target.value !== "0") {
          this.$axios
            .post("tempsJours/register", time)
            .then((res) => {
              this.alert(res);
              // Le mettre à jour dans phaseDisplayed
              if (time.nonfactId) {
                this.nonFactDisplayed.find((e) => e._id === itemId).joursId =
                  res.data.tempsId;
              } else if (time.absenceId) {
                this.absencesDisplayed.find((e) => e._id === itemId).joursId =
                  res.data.tempsId;
              } else {
                this.phasesDisplayed.find((e) => e._id === itemId).joursId =
                  res.data.tempsId;
              }
            })
            .catch((err) => this.alert(err));
        }
      }

      //Puisque les temps saisis ont bougés, le montant max de tickets restaurants est peut-être différent, je le remet à Zéro.
      this.ticketsRestaurant = 0;

      // console.log(time)
      // console.log(joursId)
    },

    //Obtenir le total d'une ligne
    getTotalLine(section, index) {
      let somme;

      if (section == 1) {
        //phaseDisplayed
        if (this.modeSaisie === "heures") {
          somme = this.phasesDisplayed[index].heures.reduce((a, b) => {
            return a + Math.max(b, 0);
          }, 0);
        } else {
          somme = parseFloat(this.phasesDisplayed[index].jours);
        }
      } else if (section == 2) {
        //nonfactDisplayed
        if (this.modeSaisie === "heures") {
          somme = this.nonFactDisplayed[index].heures.reduce((a, b) => {
            return a + Math.max(b, 0);
          }, 0);
        } else {
          somme = parseFloat(this.nonFactDisplayed[index].jours);
        }
      } else if (section == 3) {
        //absences
        if (this.modeSaisie === "heures") {
          somme = this.absencesDisplayed[index].heures.reduce((a, b) => {
            return a + Math.max(b, 0);
          }, 0);
        } else {
          somme = parseFloat(this.absencesDisplayed[index].jours);
        }
      }

      if (isNaN(somme)) {
        somme = 0;
      }

      return somme;
    },

    //Obtenir le total de la semaine ou du mois
    getTotalWeek() {
      let somme = 0;

      for (let i = 0; i < this.phasesDisplayed.length; i++) {
        somme = somme + this.getTotalLine(1, i);
      }

      for (let i = 0; i < this.nonFactDisplayed.length; i++) {
        somme = somme + this.getTotalLine(2, i);
      }

      for (let i = 0; i < this.absencesDisplayed.length; i++) {
        somme = somme + this.getTotalLine(3, i);
      }

      //Mettre à jour deltaTemps tant que je suis là.
      this.deltaTemps = this.joursMois - somme;

      if (somme % 1 == 0) {
        return somme;
      } else {
        return somme.toFixed(1);
      }
    },

    getTotalDay(i) {
      let sum = 0;
      let j = (i + 1) % 7;

      for (const phase of this.phasesDisplayed) {
        if (phase.heures[j] != null && phase.heures[j] != "") {
          sum += parseFloat(phase.heures[j]);
        }
      }

      for (const phase of this.nonFactDisplayed) {
        if (phase.heures[j] != null && phase.heures[j] != "") {
          sum += parseFloat(phase.heures[j]);
        }
      }

      for (const phase of this.absencesDisplayed) {
        if (phase.heures[j] != null && phase.heures[j] != "") {
          sum += parseFloat(phase.heures[j]);
        }
      }

      return sum;
    },

    //Passer au max de tickets restaurant : nombre de jours travaillés sur du facturable ou du non facturable. Les absences n'ouvrent pas droit aux tickets restaurant.
    trMax() {
      if (!this.isValidated) {
        this.ticketsRestaurant = Math.trunc(this.joursTravailles);
      }
    },
    //  && this.updateMontant(this.ticketsRestaurant).num % 1 == 0
    //Vérifier si la saisie manuelle est valide
    trValid() {
      //Il s'agit bien d'un nombre
      if (
        this.updateMontant(this.ticketsRestaurant) &&
        this.updateMontant(this.ticketsRestaurant).num !== 0
      ) {
        //Conversion en nombre entier
        this.ticketsRestaurant = Math.trunc(this.ticketsRestaurant);

        //Inférieur ou égal au nombre de jour travaillés
        if (this.ticketsRestaurant >= this.joursTravailles) {
          this.ticketsRestaurant = Math.trunc(this.joursTravailles);
        }
      } else {
        document.getElementById("trInput").value = 0;
        this.ticketsRestaurant == 0;
      }
    },

    //Valider la saisie
    validate() {
      let item = {
        agenceId: this.$store.state.auth.currentAgence._id,
        userId: this.$store.state.auth.currentUser._id,
        date: this.month,
        dateSaisie: new Date(),
        data: [],
        ticketsRestaurant: this.ticketsRestaurant,
      };

      //Ajout des phases
      for (let line of this.phasesDisplayed) {
        if (line.jours > 0) {
          let l = {
            projetId: line.projetId,
            phaseId: line._id,
            volume: line.jours,
          };
          item.data.push(l);
        }
      }

      //Ajout des nonFacts
      for (let line of this.nonFactDisplayed) {
        if (line.jours > 0) {
          let l = {
            nonFactId: line._id,
            volume: line.jours,
          };
          item.data.push(l);
        }
      }

      //Ajout des absences
      for (let line of this.absencesDisplayed) {
        if (line.jours > 0) {
          let l = {
            absenceId: line._id,
            volume: line.jours,
          };
          item.data.push(l);
        }
      }

      this.$axios
        .post("feuilles/", item)
        .then((response) => {
          this.isValidated = true;
          this.alert(response);
          this.exportPdfSingle(
            this.$store.state.auth.currentUser._id,
            this.dateDisplayed
          );
        })
        .catch((err) => this.alert(err));
    },

    //Export PDF de la feuille d'heure du mois pour un seul salarié
    async exportPdfSingle(userId, date) {
      //import des scripts pdfMake (voir la doc : http://pdfmake.org/#/)
      let pdfMake = require("pdfmake/build/pdfmake.js");
      if (pdfMake.vfs == undefined) {
        let pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      //Récupération des données
      let payload;
      await this.$axios
        .get(
          "saisieTemps/monthPdfSingle/" +
            this.$store.state.auth.currentAgence._id +
            "/" +
            userId +
            "/" +
            date
        )
        .then((response) => (payload = response.data))
        .catch((err) => this.alert(err));

      //Déclaration du document
      let agenceName = this.agence;
      let monthList = [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
      ];
      let month = monthList[date.getUTCMonth()];
      let today = new Date();
      let currentUser = this.username;

      let docDefinition = {
        content: [
          {
            text: agenceName + " - " + month + " " + date.getUTCFullYear(),
            fontSize: 24,
          },
          { text: payload.name + " " + payload.surname, fontSize: 14 },
          { text: " ", fontSize: 50 }, //Saut de lignes
        ],
        defaultStyle: {
          fontSize: 13,
          lineHeight: 1.2,
        },
        //Footer : "Récapitulatif imprimé le --/--/-- à 00:00 par [username]"
        footer: function (currentPage, pageCount) {
          return [
            {
              text:
                "Feuille des temps imprimée le " +
                today.toISOString().slice(0, 10) +
                " par " +
                currentUser +
                " | Page " +
                currentPage +
                "/" +
                pageCount,
              alignment: "center",
            },
          ];
        },
      };

      //Jours travaillés, facturable et non facturables
      docDefinition.content.push({
        text: "Jours travaillés",
        bold: true,
        fontSize: 16,
      });
      docDefinition.content.push({ text: " ", fontSize: 5 });
      for (const item of payload.facturable) {
        docDefinition.content.push({
          columns: [
            { width: "85%", text: item.projet + " - " + item.phase + " :" },
            {
              width: "15%",
              text: item.volume.toFixed(2) + " jrs",
              alignment: "right",
            },
          ],
          columnGap: 10,
        });
      }
      for (const item of payload.nonfact) {
        docDefinition.content.push({
          columns: [
            { width: "85%", text: item.phase + " :" },
            {
              width: "15%",
              text: item.volume.toFixed(2) + " jrs",
              alignment: "right",
            },
          ],
          columnGap: 10,
        });
      }
      docDefinition.content.push({ text: " ", fontSize: 5 });
      docDefinition.content.push({
        columns: [
          { width: "85%", text: "Total : ", alignment: "right" },
          {
            width: "15%",
            text:
              (
                payload.facturable.reduce((acc, val) => acc + val.volume, 0) +
                payload.nonfact.reduce((acc, val) => acc + val.volume, 0)
              ).toFixed(2) + " jrs",
            alignment: "right",
          },
        ],
        columnGap: 10,
      });
      docDefinition.content.push({ text: " ", fontSize: 20 });

      //Absences
      docDefinition.content.push({
        text: "Absences",
        bold: true,
        fontSize: 16,
      });
      docDefinition.content.push({ text: " ", fontSize: 5 });
      for (const item of payload.absences) {
        docDefinition.content.push({
          columns: [
            { width: "85%", text: item.phase + " :" },
            {
              width: "15%",
              text: item.volume.toFixed(2) + " jrs",
              alignment: "right",
            },
          ],
          columnGap: 10,
        });
        docDefinition.content.push({
          text: "    > Du  ......................................  Au  ......................................",
        });
      }
      docDefinition.content.push({ text: " ", fontSize: 5 });
      docDefinition.content.push({
        columns: [
          { width: "85%", text: "Total : ", alignment: "right" },
          {
            width: "15%",
            text:
              payload.absences
                .reduce((acc, val) => acc + val.volume, 0)
                .toFixed(2) + " jrs",
            alignment: "right",
          },
        ],
        columnGap: 10,
      });
      docDefinition.content.push({ text: " ", fontSize: 20 });

      //Tickets Restaurants
      docDefinition.content.push({
        text: "Tickets Restaurants : " + payload.ticketsRestaurant,
      });
      docDefinition.content.push({ text: " ", fontSize: 20 });
      docDefinition.content.push({
        text: "Signature (" + payload.name + " " + payload.surname + ") :",
      });

      //Export du fichier [aaaa.mm - Temps Mois(user).pdf]
      pdfMake
        .createPdf(docDefinition)
        .download(
          date.getUTCFullYear().toString() +
            "." +
            (
              (date.getUTCMonth() + 1 < 10 ? "0" : "") +
              (date.getUTCMonth() + 1)
            ).toString() +
            " - " +
            "Temps " +
            month +
            "(" +
            payload.name +
            " " +
            payload.surname +
            ").pdf"
        );
    },

    //Au clic sur le nom d'un projet, afficher sa page projet sur l'onglet analyse
    clickedLink(projetId) {
      this.$router.push("/projet/" + projetId + "/analyse/");
    },

    //Eviter la modification de la valeur d'un "input type=Number" par la molette
    noWheel(e) {
      //Si je fais juste un "@wheel.prevent" pour l'élément input en HTML (équivalent de : @wheel="$event.preventDefault()"), ça arrêtera le scroll de la page lorsque le curseur est sur un input, même si cet input n'est pas focused
      //Si je fais @wheel="$event.blur()", je sors de l'input (blur() est l'inverse de focus()), ce qui n'est pas ce que souhaite l'user.
      //Je vais donc tester si je suis dans l'input (focused) ou pas avant de prevent.

      if (e.target === document.activeElement) {
        e.preventDefault();
      }

      //Si ça rame trop, je peux toujours faire avec blur(), et tant pis si l'user sors quelques fois de l'input...
    },
  },
};
</script>

<template>
  <div class="page-main">
    <Banner bannerImage="bannerTemps" />
    <div v-if="modeSaisie">
      <TabMenu>
        <template v-slot:body>
          <Tab
            v-if="modeSaisie == 'jours'"
            text="Saisie des jours"
            route="/saisie"
            customWidth="160"
          />
          <Tab
            v-if="modeSaisie == 'heures'"
            text="Saisie des heures"
            route="/saisie"
            customWidth="160"
          />
          <Tab
            v-if="modeSaisie == 'error'"
            text="Erreur : mode de saisie incorrect"
            route="/saisie"
            customWidth="250"
          />
        </template>
      </TabMenu>

      <div class="page-main-container">
        <Calendrier
          class="calendrier"
          @changed="changedPeriod"
          @unvalidated="isValidated = false"
          :mode="modeSaisie"
          @nbJoursOpen="
            (nbJoursOpen) => {
              joursMois = nbJoursOpen;
            }
          "
          :isValidated="isValidated"
          @printSingle="exportPdfSingle($event.userId, $event.dateDisplayed)"
        />

        <div class="temps">
          <Form
            label="Ajouter une phase"
            text="Ajouter"
            @submit="add($event)"
            formIndex="1"
          >
            <template v-slot:body>
              <div class="col2__formBody">
                <select
                  @change="majPhases($event.target.value)"
                  v-if="phases.length"
                >
                  <option value="">Projet</option>
                  <option
                    v-for="projet in projets"
                    :key="projet._id"
                    :value="projet._id"
                  >
                    {{ projet.name + " - " + projet.localisation }}
                  </option>
                  <option value="">----------</option>
                  <option value="taches">Tâches non facturables</option>
                  <option value="absences">Absences</option>
                </select>
                <select v-else>
                  <option>Chargement ...</option>
                </select>
                <select v-if="phasesSelect.length != 0">
                  <option value="">Phase</option>
                  <option
                    v-for="phase in phasesSelect"
                    :key="phase._id"
                    :value="phase._id"
                  >
                    {{ phase.name }}
                  </option>
                </select>
              </div>
            </template>
          </Form>

          <div v-if="fullyLoaded">
            <div v-if="modeSaisie == 'heures'" class="col2__header">
              <div class="col2__header__empty1"></div>
              <div v-for="jour in joursSemaine" :key="jour.getUTCDate()">
                {{ jour.getUTCDate() }}
              </div>
              <div class="col2__header__empty2"></div>
            </div>

            <div v-if="modeSaisie == 'jours'" class="col2__helper">
              Saisissez le nombre de jours travaillés pour chaque phase ce
              mois-ci.
              <div class="col2__header__empty2"></div>
            </div>

            <Section text="Phases des projets">
              <template v-slot:body>
                <div class="col2__body">
                  <Projet
                    v-for="(phase, index) in phasesDisplayed"
                    :key="phase._id"
                    :name="phase.projet"
                    :localisation="phase.name"
                    class="col2__body__card"
                    @clicked-link="clickedLink(phase.projetId)"
                    :headerWidth="modeSaisie == 'jours' ? 360 : 160"
                  >
                    <template v-slot:body>
                      <div
                        v-if="modeSaisie == 'heures'"
                        class="col2__body__cardContent"
                      >
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime($event, 0, phase._id, phase.heuresId[1])
                          "
                          v-model="phasesDisplayed[index].heures[1]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime($event, 1, phase._id, phase.heuresId[2])
                          "
                          v-model="phasesDisplayed[index].heures[2]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime($event, 2, phase._id, phase.heuresId[3])
                          "
                          v-model="phasesDisplayed[index].heures[3]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime($event, 3, phase._id, phase.heuresId[4])
                          "
                          v-model="phasesDisplayed[index].heures[4]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime($event, 4, phase._id, phase.heuresId[5])
                          "
                          v-model="phasesDisplayed[index].heures[5]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime($event, 5, phase._id, phase.heuresId[6])
                          "
                          v-model="phasesDisplayed[index].heures[6]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime($event, 6, phase._id, phase.heuresId[0])
                          "
                          v-model="phasesDisplayed[index].heures[0]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                      </div>
                      <div
                        v-if="modeSaisie == 'jours'"
                        class="col2__body__cardContentDays"
                      >
                        <input
                          class="col2__body__cardContent__input"
                          :disabled="isValidated"
                          type="Number"
                          step="0.01"
                          min="0"
                          style="grid-column: 2"
                          @change="
                            changeJours($event, phase._id, phase.joursId)
                          "
                          v-model="phasesDisplayed[index].jours"
                          @wheel="noWheel($event)"
                        />
                      </div>
                    </template>
                    <template v-slot:footer>
                      <div class="col2__body__cardFooter">
                        <span
                          v-if="!phase.isFav"
                          class="material-icons"
                          @click="addfavoris(phase._id, false, false)"
                          >star_border</span
                        >
                        <span
                          v-if="phase.isFav"
                          class="material-icons col2__body__cardFooter__fav"
                          @click="delfavoris(phase._id, false, false)"
                          >star</span
                        >
                      </div>
                    </template>
                  </Projet>
                  <div
                    v-if="phasesDisplayed.length == 0"
                    class="col2__body__helper"
                  >
                    Aucune phase. Pour ajouter une phase d'un projet, utiliser
                    le formulaire en haut de la page.
                  </div>
                </div>
              </template>
            </Section>

            <Section text="Éléments non facturables">
              <template v-slot:body>
                <div class="col2__body">
                  <Projet
                    v-for="(nonFact, index) in nonFactDisplayed"
                    :key="nonFact._id"
                    :name="nonFact.projet"
                    :localisation="nonFact.name"
                    class="col2__body__card"
                    :headerWidth="modeSaisie == 'jours' ? 360 : 160"
                  >
                    <template v-slot:body>
                      <div
                        v-if="modeSaisie == 'heures'"
                        class="col2__body__cardContent"
                      >
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime(
                              $event,
                              0,
                              nonFact._id,
                              nonFact.heuresId[1]
                            )
                          "
                          v-model="nonFactDisplayed[index].heures[1]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime(
                              $event,
                              1,
                              nonFact._id,
                              nonFact.heuresId[2]
                            )
                          "
                          v-model="nonFactDisplayed[index].heures[2]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime(
                              $event,
                              2,
                              nonFact._id,
                              nonFact.heuresId[3]
                            )
                          "
                          v-model="nonFactDisplayed[index].heures[3]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime(
                              $event,
                              3,
                              nonFact._id,
                              nonFact.heuresId[4]
                            )
                          "
                          v-model="nonFactDisplayed[index].heures[4]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime(
                              $event,
                              4,
                              nonFact._id,
                              nonFact.heuresId[5]
                            )
                          "
                          v-model="nonFactDisplayed[index].heures[5]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime(
                              $event,
                              5,
                              nonFact._id,
                              nonFact.heuresId[6]
                            )
                          "
                          v-model="nonFactDisplayed[index].heures[6]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime(
                              $event,
                              6,
                              nonFact._id,
                              nonFact.heuresId[0]
                            )
                          "
                          v-model="nonFactDisplayed[index].heures[0]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                      </div>
                      <div
                        v-if="modeSaisie == 'jours'"
                        class="col2__body__cardContentDays"
                      >
                        <input
                          class="col2__body__cardContent__input"
                          :disabled="isValidated"
                          type="Number"
                          step="0.01"
                          min="0"
                          style="grid-column: 2"
                          @change="
                            changeJours($event, nonFact._id, nonFact.joursId)
                          "
                          v-model="nonFactDisplayed[index].jours"
                          @wheel="noWheel($event)"
                        />
                      </div>
                    </template>
                    <template v-slot:footer>
                      <div class="col2__body__cardFooter">
                        <span
                          v-if="!nonFact.isFav"
                          class="material-icons"
                          @click="addfavoris(false, nonFact._id, false)"
                          >star_border</span
                        >
                        <span
                          v-if="nonFact.isFav"
                          class="material-icons col2__body__cardFooter__fav"
                          @click="delfavoris(false, nonFact._id, false)"
                          >star</span
                        >
                      </div>
                    </template>
                  </Projet>
                  <div
                    v-if="nonFactDisplayed.length == 0"
                    class="col2__body__helper"
                  >
                    Aucun élément non facturable. Pour ajouter un élément,
                    utiliser le formulaire en haut de la page.
                  </div>
                </div>
              </template>
            </Section>

            <Section text="Absences">
              <template v-slot:body>
                <div class="col2__body">
                  <Projet
                    v-for="(abs, index) in absencesDisplayed"
                    :key="abs._id"
                    :name="abs.projet"
                    :localisation="abs.name"
                    class="col2__body__card"
                    :headerWidth="modeSaisie == 'jours' ? 180 : 160"
                  >
                    <template v-slot:body>
                      <div
                        v-if="modeSaisie == 'heures'"
                        class="col2__body__cardContent"
                      >
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime($event, 0, abs._id, abs.heuresId[1])
                          "
                          v-model="absencesDisplayed[index].heures[1]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime($event, 1, abs._id, abs.heuresId[2])
                          "
                          v-model="absencesDisplayed[index].heures[2]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime($event, 2, abs._id, abs.heuresId[3])
                          "
                          v-model="absencesDisplayed[index].heures[3]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime($event, 3, abs._id, abs.heuresId[4])
                          "
                          v-model="absencesDisplayed[index].heures[4]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime($event, 4, abs._id, abs.heuresId[5])
                          "
                          v-model="absencesDisplayed[index].heures[5]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime($event, 5, abs._id, abs.heuresId[6])
                          "
                          v-model="absencesDisplayed[index].heures[6]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                        <input
                          type="Number"
                          step="0.01"
                          min="0"
                          @change="
                            changeTime($event, 6, abs._id, abs.heuresId[0])
                          "
                          v-model="absencesDisplayed[index].heures[0]"
                          @wheel="noWheel($event)"
                          class="col2__body__cardContent__input"
                        />
                      </div>
                      <div
                        v-if="modeSaisie == 'jours'"
                        class="col2__body__cardContentDays"
                      >
                        <!-- absenceInfo -->
                        <!-- <input class="col2__body__cardContent__input" :disabled="isValidated" type="text" style="text-align: left; padding: 0 5px">                     -->
                        <input
                          class="col2__body__cardContent__input"
                          :disabled="isValidated"
                          type="Number"
                          step="0.01"
                          min="0"
                          style="grid-column: 2"
                          @change="changeJours($event, abs._id, abs.joursId)"
                          v-model="absencesDisplayed[index].jours"
                          @wheel="noWheel($event)"
                        />
                      </div>
                    </template>
                    <template v-slot:footer>
                      <div class="col2__body__cardFooter">
                        <span
                          v-if="!abs.isFav"
                          class="material-icons"
                          @click="addfavoris(false, false, abs._id)"
                          >star_border</span
                        >
                        <span
                          v-if="abs.isFav"
                          class="material-icons col2__body__cardFooter__fav"
                          @click="delfavoris(false, false, abs._id)"
                          >star</span
                        >
                      </div>
                    </template>
                  </Projet>
                  <div
                    v-if="absencesDisplayed.length == 0"
                    class="col2__body__helper"
                  >
                    Aucune absence. Pour ajouter un élément, utiliser le
                    formulaire en haut de la page.
                  </div>
                </div>
              </template>
            </Section>

            <Section
              text="Total"
              v-if="modeSaisie == 'heures'"
              underlined="true"
            >
              <template v-slot:body>
                <div class="col2__header">
                  <div class="col2__header__empty1"></div>
                  <div
                    v-for="(jour, index) in joursSemaine"
                    :key="jour.getUTCDate()"
                    class="col2__footer__sum"
                  >
                    {{ getTotalDay(index) }}
                  </div>
                  <div class="col2__header__empty2"></div>
                </div>
              </template>
            </Section>
          </div>
          <div v-else>
            <Spinner />
          </div>
        </div>

        <div class="infos">
          <Section text="Total" class="total blockInfo" underlined="true">
            <template v-slot:body>
              <div class="total__line">
                <div v-if="modeSaisie == 'heures'" class="total__line__left">
                  Heures sur la semaine :
                </div>
                <div v-if="modeSaisie == 'heures'" class="total__line__right">
                  {{ getTotalWeek() }} h
                </div>
                <div v-if="modeSaisie == 'jours'" class="total__line__left">
                  Jours saisis :
                </div>
                <div v-if="modeSaisie == 'jours'" class="total__line__right">
                  {{ getTotalWeek() }} j
                </div>
              </div>
              <div class="total__line" v-if="modeSaisie == 'jours'">
                <div class="total__line__left">Jours travaillés :</div>
                <div class="total__line__right">{{ joursTravailles }} j</div>
              </div>
            </template>
          </Section>
          <Section text="Éléments favoris" class="blockInfo" underlined="true">
            <template v-slot:body>
              <div>
                <span class="material-icons blockInfo__fav">star_border</span>
                >
                <span
                  class="material-icons col2__body__cardFooter__fav blockInfo__fav"
                  >star</span
                >
                Vous pouvez mémoriser certaines phases dans vos favoris. Elles
                s'afficheront automatiquement à chaque période.
              </div>
            </template>
          </Section>
          <Section
            v-if="modeSaisie == 'jours'"
            text="Validation"
            class="blockInfo"
            underlined="true"
          >
            <template v-slot:body>
              <div>
                <p>
                  Une fois validée, la saisie mensuelle n'est plus modifiable.
                </p>

                <div class="blockInfo-TR">
                  <span>Tickets restaurants :</span>
                  <input
                    :disabled="isValidated"
                    id="trInput"
                    type="number"
                    v-model="ticketsRestaurant"
                    :max="Math.trunc(joursTravailles)"
                    @change="trValid()"
                  />
                  <span class="material-icons" @click="trMax()">upgrade</span>
                </div>

                <!-- Si la saisie est déjà validée -->
                <div
                  v-if="isValidated"
                  class="blockInfo-validate blockInfo-validate-done"
                >
                  <span class="material-icons">done</span>
                  <span class="blockInfo-validate-done-text"
                    >Saisie validée</span
                  >
                </div>
                <!-- Si l'user est en temps partiel (feuille des temps validable quelque soit le nombre de jours saisis) -->
                <div
                  v-else-if="
                    $store.state.auth.currentUser.tempsPartiel == true &&
                    deltaTemps > 0
                  "
                  class="blockInfo-validate"
                  @click="validate()"
                >
                  <span v-if="deltaTemps > 0">Valider la saisie</span>
                </div>
                <!-- Saisie non validable -->
                <div
                  v-else-if="deltaTemps != 0"
                  class="blockInfo-validate blockInfo-validate-disabled"
                >
                  <span v-if="deltaTemps > 0"
                    >Il vous reste {{ deltaTemps }} jours à saisir</span
                  >
                  <span v-else-if="deltaTemps < 0"
                    >Vous avez saisi {{ -deltaTemps }} jours en trop</span
                  >
                </div>
                <!-- Saisie validable -->
                <div v-else class="blockInfo-validate" @click="validate()">
                  Valider la saisie
                </div>
              </div>
            </template>
          </Section>
          <!-- <Section text="Unités multiples" class="blockInfo" underlined="true" v-if="this.$store.state.auth.currentAgence._id == '5f887141fd9cc44bd4fa64a8'">
              <template v-slot:body>
                <div style="color: red;">
                  TODO : Afficher une alerte s'il y a des temps saisis dans deux unités différentes sur une même période.
                </div>
              </template>
            </Section> -->
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/main.scss";

@include page-main;
.page-main-container {
  @include grid-alpha;
}

.calendrier {
  grid-column: 1;
}

.temps {
  grid-column: 2 / span 2;
}

.infos {
  grid-column: 4;
}

.col2 {
  &__formBody {
    display: flex;
    align-items: center;
    max-width: 75%;

    & select {
      border: none;
      @include myField;
      margin: 5px 15px 5px 0;
      background-color: $black-lighter;
    }

    & select:nth-child(1) {
      max-width: 300px;
      min-width: 300px;
    }
    & select:nth-child(2) {
      max-width: 150px;
      min-width: 150px;
    }
  }

  &__helper {
    @include myFont;
    font-size: 13px;
    width: 100%;
    text-align: right;
    // margin: 30px 0 -17px 0;
    margin: 30px 0 15px 0;
    color: $black-bold;
  }

  &__header {
    display: grid;
    grid-template-columns: 256px repeat(7, 1fr) 34px; //256px = largeur dans le composant projetCard (image + marge + header + border-left + 1x rowgap) | 7 colonnes | (largeur + margin + border-right - 1x rowgap) du cardFooter dans ce doc
    gap: 0px 15px; //row-gap column-gap
    @include myFont;
    color: $black-bolder;
    // margin: 30px 0 -17px 0;
    margin: 30px 0 15px 0;

    & * {
      text-align: center;
    }
  }

  &__body {
    margin: 0 0 30px 0;
    &__card {
      margin: 0 0 6px 0;
    }

    &__cardContent {
      height: 100%;
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      gap: 0px 15px; //row-gap column-gap

      &__input {
        border: none;
        width: 100%;
        // min-width: 30px; //risque de permettre un décallage du header, ou alors il faut que je fasse pareil sur les sous élément du header.
        background-color: $main-lighter;
        border-radius: 3px;
        text-align: center;
        @include myFont;
        font-size: 16px;
        margin: 8px 0 8px 0;
        color: $black-bolder;

        // Supprimer les flèches du type Number
        -moz-appearance: textfield;
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }
    }

    &__cardContentDays {
      height: 100%;
      display: grid;
      grid-template-columns: 1fr 34px;
      gap: 0px 20px; //row-gap column-gap
      margin-right: 15px;
    }

    &__cardContent2 {
      height: 100%;
      display: flex;
      justify-content: flex-end;
      padding: 0 15px 0 0;

      & input {
        border: none;
        width: 34px; //Un carré
        background-color: $main-lighter;
        border-radius: 3px;
        text-align: center;
        @include myFont;
        font-size: 16px;
        margin: 8px 0 8px 0;
        color: $black-bolder;

        // Supprimer les flèches du type Number
        -moz-appearance: textfield;
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }
    }

    &__cardFooter {
      width: 25px;
      margin: 3px 10px 0 13px;

      & span {
        cursor: pointer;
      }

      &__fav {
        color: $main;
      }
    }

    &__helper {
      @include myFont;
      font-size: 13px;
      color: $black;
    }
  }

  &__footer {
    &__sum {
      // color: $main;
      font-size: 13px;
      position: relative;
      top: -20px;
    }
  }
}

.blockInfo {
  @include myFont;
  margin: 0 0 40px 0;
  font-size: 13px;

  &__fav {
    font-size: 16px;
    vertical-align: text-top;
  }

  &-TR {
    display: flex;

    & span:first-child {
      flex: 1;
    }

    & > input {
      @include myField;
      background-color: $black-lighter;
      margin: -1px 0 8px 0;
      width: 35px;
      text-align: center;

      // Supprimer les flèches du type Number
      -moz-appearance: textfield;
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }

    & > .material-icons {
      margin: -2px 0 0px 10px;
    }
  }

  &-validate {
    @include myButton;
    margin-top: 10px;
    border: solid 1px $main;
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;

    &-disabled {
      background-color: $black-lighter;
      color: $main;

      &:hover {
        box-shadow: none;
        cursor: not-allowed;
      }
    }

    &-done {
      background-color: $green;
      border: solid 1px $green;

      & > .material-icons {
        color: white;
        margin: 0px 8px 0px 0;
        cursor: default;
      }

      &:hover {
        box-shadow: none;
        cursor: default;
      }
    }
  }
}

.total {
  &__line {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    margin: 5px 0;
  }
}

.list-enter-active,
.list-leave-active {
  transition: all 0.3s;
}
.list-enter {
  opacity: 0;
  // transform: translateY(30px);
}

.list-leave-to {
  opacity: 0;
}
</style>
